import React, { HTMLAttributes } from 'react'

export const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0']

export interface PostCodePropsModel extends HTMLAttributes<HTMLElement> {
  onPinClick: (value: string) => void
  handleModalOpen: () => void
  handleDelete: () => void
}
